import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
  output,
} from '@angular/core';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { NavigationItem } from '@app/shared/interfaces/navigation-item';
import { ProfileService, DataTestDirective } from '@outlaw/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgTemplateOutlet } from '@angular/common';

@Component({
  selector: 'app-navigation-list',
  templateUrl: './navigation-list.component.html',
  styleUrls: ['./navigation-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    RouterLink,
    RouterLinkActive,
    MatTooltipModule,
    DataTestDirective,
    NgTemplateOutlet,
  ],
})
export class NavigationListComponent {
  private profileService = inject(ProfileService);
  private router = inject(Router);

  navigationItems = input<NavigationItem[]>([]);
  navigationClick = output<string>();

  filteredNavigationItems = computed(() => {
    const user = this.profileService.getUser();
    const items = this.navigationItems();

    // Filter out profile link for guests
    if (!user) {
      return items.filter((item) => item.id !== 'profile');
    }

    return items;
  });

  onNavigationClick(item: NavigationItem): void {
    // Don't emit for external links (they open in new tab)
    if (item.isExternal) {
      return;
    }

    // Don't emit for disabled items
    if (!item.route) {
      return;
    }

    // Emit the item ID so parent can close sidebar
    this.navigationClick.emit(item.id);

    // Programmatically navigate
    this.router.navigate([item.route]);
  }
}
